import { render, staticRenderFns } from "./order-display.vue?vue&type=template&id=67d301a2&scoped=true"
import script from "./order-display.vue?vue&type=script&lang=js"
export * from "./order-display.vue?vue&type=script&lang=js"
import style0 from "./order-display.vue?vue&type=style&index=0&id=67d301a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d301a2",
  null
  
)

export default component.exports